module.exports = __webpack_public_path__ + "static/media/logo-mercantil_andina.12462840.svg";